import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type LayoutProps = {
  children: ReactNode;
  className?: string;
};

export const Layout = ({ children, className }: LayoutProps) => {
  return <div className={twMerge("mx-auto max-w-6xl pt-8 pb-20 2xl:px-8", className)}>{children}</div>;
};
